import { TesterFeature } from '../../store/types';

const mkTesterTourClassName = (feature: TesterFeature, step: number) =>
  `tour-tester-${feature}-step-${step}`;

export default mkTesterTourClassName;
